import { Injectable } from '@angular/core';
import { catchError, map } from "rxjs/operators";
import { environment } from "../../../../../environments/environment";
import { GenericHttpService } from "../../../services/generic-http.service";
import { Observable } from "rxjs";
import { GenericUtils } from './../../../utilities/generic-utils';
import * as moment from "moment";

@Injectable({
    providedIn: 'root'
})
export class DataService {
    apiUrl = environment.gateWayHost;
    editItem: any;
    config: any;
    interval: any;
    weekcount = 0
    filters = null;
    getTimeType = {

        'hour': function (time) {
            return `${moment(time).format('HH:mm')} hours`;
        },
        'day': function (time) {
            return moment(time).format('DD-MMM');
        },
        'week': function (time) {
            //return moment(time).format('dddd');
            return `${++this.weekcount} week`;
        }.bind(this),
        'month': function (time) {
            return moment(time).format('MMM');
        }
    };

    getDateArray = {

        "day": this.getDayDates.bind(this),
        "week": this.getWeekDates.bind(this),
        "month": this.getMonthDates.bind(this)
    }
    constructor(public generic: GenericHttpService, private genericUtils: GenericUtils) { }

    getData(url, config, params): Observable<any> {
        this.filters = params;
        this.interval = params['interval_type'];
        const option = {
            method: "GET",
            url: `${this.apiUrl}${url}`,
            query: params
        };
        this.config = config;
        const functionToExecute = this[config['functionToCall']].bind(this);
        return this.generic.httpRequest(option).pipe(
            catchError(this.generic.handleError),
            map(functionToExecute)
        );
    }

    processInboundWarehouseSLATrend(data: any) {
        if (!Object.keys(data.data).length) return null;
        const sla = [],
            quantity_shipped = [],
            labels = [],
            originalData = data.data[0][Object.keys(data.data[0])[0]],
            datesArray = this.getDateArray[this.interval]('completed_date__start', 'completed_date__end');
        let returnNull = false;

        if (!originalData.length) return null;
        for (let i = 0; i < datesArray.length; i++) {
            let dataToPush = null;

            for (let j = 0; j < originalData.length; j++) {
                if (originalData[j]['stocked_by'] === datesArray[i]) {
                    dataToPush = originalData[j];
                    labels.push(this.getTimeType[this.interval](originalData[j]["stocked_by"]));
                    quantity_shipped.push(originalData[j]["stocked_quantity"] || 0);
                    sla.push(Number(originalData[j]["sla"].toFixed(2)) || 0);
                    break;
                }
                if (originalData[j]['stocked_by'] === 'Total' && originalData[j]["eligible_quantity"] === 0 && originalData[j]["stocked_quantity"] === 0)
                    return null;
            }
            if (!dataToPush) {
                labels.push(this.getTimeType[this.interval](datesArray[i]));
                quantity_shipped.push(0);
                sla.push(0);
            }
        }

        this.weekcount = 0;
        return { labels, values: [quantity_shipped, sla] };
    };

    processOutboundWarehouseSLATrend(data: any) {
        if (!Object.keys(data.data).length) return null;
        const sla = [],
            quantity_shipped = [],
            labels = [],
            originalData = data.data[0][Object.keys(data.data[0])[0]],
            datesArray = this.getDateArray[this.interval]('shipped_date__start', 'shipped_date__end');
        let returnNull = false;

        if (!originalData.length) return null;
        for (let i = 0; i < datesArray.length; i++) {
            let dataToPush = null;

            for (let j = 0; j < originalData.length; j++) {
                if (originalData[j]['shipped_by'] === datesArray[i]) {
                    dataToPush = originalData[j];
                    labels.push(this.getTimeType[this.interval](originalData[j]["shipped_by"]));
                    quantity_shipped.push(originalData[j]["shipped_quantity"] || 0);
                    sla.push(Number(originalData[j]["sla"].toFixed(2)) || 0);
                    break;
                }
                if (originalData[j]['shipped_by'] === 'Total' && originalData[j]["eligible_quantity"] === 0 && originalData[j]["shipped_quantity"] === 0)
                    return null;
            }
            if (!dataToPush) {
                labels.push(this.getTimeType[this.interval](datesArray[i]));
                quantity_shipped.push(0);
                sla.push(0);
            }
        }

        this.weekcount = 0;
        return { labels, values: [quantity_shipped, sla] };
    };


    getDayDates(startKey, endKey) {
        let startDate = moment(this.filters[startKey]);
        const endDate = moment(this.filters[endKey]);
        const datesArray = [];
        while (startDate <= endDate) {
            datesArray.push(startDate.format("YYYY-MM-DD"));
            startDate = moment(startDate).add(1, 'days');
        }
        return datesArray;
    }

    getWeekDates(startKey, endKey) {
        let startDate = moment(this.filters[startKey]);
        const startDay = startDate.day();
        const endDate = moment(this.filters[endKey]);
        startDate = moment(startDate).subtract(startDay === 0 ? 6 : startDay-1, 'day');

        const datesArray = []

        while (startDate <= endDate) {
            datesArray.push(startDate.format("YYYY-MM-DD"));
            startDate = moment(startDate).add(7, 'days');
        }
        return datesArray;
    }

    getMonthDates(startKey, endKey) {
        let startDate = moment(this.filters[startKey]);
        const startDay = startDate.date();
        startDate = moment(startDate).subtract((startDay - 1), 'days'); // 1st of the month
        const endDate = moment(this.filters[endKey]);
        const datesArray = [];
        while (startDate <= endDate) { // if end date is equal to a 1st of a month, even that month is included.
            datesArray.push(startDate.format("YYYY-MM-DD"));
            startDate = moment(startDate).add(1, 'month'); // adding a month
        }
        return datesArray;
    }

    createChart(chartData, options) {
        const chart = this.genericUtils.deepCopyFunction(options[0]);
        chart.xAxis[0].categories = chartData.labels;
        if (chartData.values[0].length <= 1) {
            chart.plotOptions.line.marker.enabled = true;
        }
        for (let index = 0; index < chartData.values.length; index++) {
            chart.series[index].data = chartData.values[index];
        }
        return chart;
    }

}
